(function () {
  'use strict';

  function initSection(section) {
    var list = section.querySelector('[data-rsb-list]');
    var moreBtn = section.querySelector('[data-rsb-show-more]');
    var moreWrap = section.querySelector('.rsb__more-wrap');
    var cards = section.querySelectorAll('[data-rsb-card]');
    var visibleCount = parseInt(section.getAttribute('data-rsb-mobile-visible'), 10) || 2;
    if (!list || !cards.length) return;

    function applyMobileVisibility() {
      var isDesktop = window.matchMedia('(min-width: 990px)').matches;
      cards.forEach(function (card, i) {
        if (!isDesktop && i >= visibleCount) {
          card.setAttribute('data-rsb-hidden', '');
        } else {
          card.removeAttribute('data-rsb-hidden');
        }
      });
      if (moreWrap) {
        moreWrap.style.display = (!isDesktop && cards.length > visibleCount) ? '' : 'none';
      }
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        cards.forEach(function (card) {
          card.removeAttribute('data-rsb-hidden');
        });
        if (moreWrap) moreWrap.style.display = 'none';
      });
    }

    applyMobileVisibility();
    window.addEventListener('resize', applyMobileVisibility);
  }

  function init() {
    document.querySelectorAll('.rsb').forEach(function (section) {
      initSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
